<template>
  <div class="footerTop">
    <div class="container">
      <ul uk-accordion class="cover">
        <li>
          <a class="uk-accordion-title" href="#" role="button">
            <p :style="{ fontSize: fontSize.p + 'em' }">縮合</p>
          </a>
          <div class="uk-accordion-content">
            <!--------------中心介紹----------------->
            <div class="all_message_item">
              <h3 class="collapsed-title" :style="{ fontSize: fontSize.h4 + 'em' }">中心介紹</h3>
              <ul>
                <li>
                  <router-link to="/About" title="國人海外就業資源中心">國人海外就業資源中心</router-link>
                </li>
              </ul>
            </div>
            <!--------------海外就業國家---------------->
            <div class="all_message_item">
              <h3 class="collapsed-title" :style="{ fontSize: fontSize.h4 + 'em' }">海外就業國家</h3>
              <ul class="all_message_country">
                <li v-for="coun in countryList" :key="coun.nodeId" class="area">
                  <template v-for="country in coun.countries" :key="country.countryId">
                    <a :href="`/${country.countryId}`" :title="country.countryName">
                      <p :style="{ fontSize: fontSize.p + 'em' }">
                        {{ country.countryName }}
                      </p>
                    </a>
                  </template>
                </li>
              </ul>
            </div>
            <!--------------海外就業經驗分享----------------->
            <div class="all_message_item">
              <h3 class="collapsed-title" :style="{ fontSize: fontSize.h4 + 'em' }">
                海外就業經驗分享
              </h3>
              <ul>
                <li v-for="(share, index) in shares" :key="index">
                  <a :href="share.link" :title="share.titleArea">
                    <p :style="{ fontSize: fontSize.p + 'em' }">
                      {{ share.titleArea }}
                    </p>
                  </a>
                </li>
              </ul>
            </div>
            <!--------------海外就業指南----------------->
            <div class="all_message_item">
              <h3 class="collapsed-title" :style="{ fontSize: fontSize.h4 + 'em' }">海外就業指南</h3>
              <ul class="all_guides nowrap">
                <li v-for="message in guides" :key="message.pageId">
                  <a :href="message.pageContent" :title="'[另開新視窗]' + message.nodeName" target="_blank">
                    <p :style="{ fontSize: fontSize.p + 'em' }">
                      {{ message.pageTitle }}
                    </p>
                  </a>
                </li>
              </ul>
            </div>
            <!--------------海外人才返國專區----------------->
            <div class="all_message_item">
              <h3 class="collapsed-title" :style="{ fontSize: fontSize.h4 + 'em' }">
                海外人才返國專區
              </h3>
              <ul>
                <li v-for="(people, index) in Return" :key="index">
                  <a :href="people.link" :title="people.titleArea">
                    <p :style="{ fontSize: fontSize.p + 'em' }">
                      {{ people.titleArea }}
                    </p>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
//  無障礙文字子層引入設定
import { reactive, ref, inject } from "vue";
import { apiCountry } from "@/api/api.js";
import { apiGuide } from "@/api/api.js";

export default {
  name: "FooterTop",
  setup() {
    //  無障礙文字子層引入設定
    let fontSize = inject("fontSize");
    const countryList = reactive([]);
    const guides = reactive([]);

    const shares = ref([
      {
        titleArea: "影音專區",
        link: "/video",
      },
      {
        titleArea: "專家建議",
        link: "/article",
      },
      {
        titleArea: "達人投稿",
        link: "/submit",
      },
    ]);
    apiGuide()
      .then((res) => {
        res.data.forEach((i) => {
          guides.push(i);
        });
      })
      .catch((err) => {
        console.log("海外就業指南資訊失敗", err);
      });
    apiCountry()
      .then((res) => {
        res.data.areas.forEach((area) => {
          countryList.push(area);
        });
      })
      .catch((err) => {
        console.log("漢堡國家列表失敗", err);
      });
    const Return = ref([
      {
        titleArea: "返國資訊",
        link: "/Return_employment",
      },
    ]);

    return {
      countryList,
      shares,
      Return,
      guides,
      fontSize,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.footerTop {
  margin-top: 16px;
  @include md {
    display: none;
  }
}
.uk-accordion-title {
  display: block;
  border-bottom: 5px solid $main_color;
  position: relative;
  text-align: center;
  p {
    font-size: 1.125em;
    padding: 60px 0 30px;
    color: $main_color;
  }
}
.uk-accordion-title::after {
  position: absolute;
  top: 92px;
  margin-left: -12px;
}
.uk-accordion-content {
  background: url(../../img/help_tel.svg) no-repeat top/90%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 10px 80px 30px;
  margin-bottom: 40px;
  @include xl {
    padding: 10px 20px 30px;
  }
  .all_message_item {
    width: $width / 6;
    padding-top: 10px;
    & > ul:nth-child(4) {
      padding-left: 70px;
    }
    .all_message_country {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      flex-direction: column;
      flex-wrap: wrap;
      height: 276px;
      text-align: left;
      &.nowrap {
        flex-wrap: nowrap;
        padding-left: 70px;
        @media screen and(max-width: 1440px) {
          padding-left: 37px;
          height: 300px;
        }
        @include xl {
          padding-left: 35px;
        }
        @include lg {
          padding-left: 0px;
        }
      }
    }
    .all_guides {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      flex-direction: column;
      flex-wrap: wrap;
      text-align: left;

      &.nowrap {
        flex-wrap: nowrap;
        padding-left: 70px;

        @media screen and(max-width: 1440px) {
          padding-left: 37px;
        }

        @include xl {
          padding-left: 35px;
        }

        @include lg {
          padding-left: 0px;
        }
      }
    }
    li {
      &.area {
        display: flex;
        flex-direction: column;
        transform: translateX(40px);
        @media screen and(max-width: 1700px) {
          transform: translateX(25px);
        }
        @media screen and(max-width: 1500px) {
          transform: translateX(10px);
        }
        @media screen and(max-width: 1000px) {
          transform: translateX(0px);
        }
        a {
          margin-right: 17px;
        }
      }
      p {
        padding: 2px 0;
      }
    }
    ul {
      margin-top: 10px;
      > .area:nth-child(3) {
        height: 250px;
        flex-wrap: wrap;
        transform: translateX(-10px);
        @media screen and(max-width: 1200px) {
          transform: translateX(0px);
          flex-wrap: nowrap;
        }
      }
    }
  }
}
.collapsed-title {
  text-align: center;
  border-bottom: 3px solid #024d73;
  padding-bottom: 6px;
  color: $green_color;
  @include lg {
    font-size: 1em;
  }
}
a {
  border-bottom: 1.4px solid transparent;
  &:hover {
    border-bottom: 1.4px solid $main_color;
  }
  &.uk-accordion-title {
    &:hover {
      border-bottom: 5px solid #024d73;
    }
  }
}
</style>
